module.exports = __webpack_public_path__ + "static/media/ConfirmationAnomalieScreen_elCheck_1739166588.d36f9f0d.png";